import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const WORDS = [
  "Strategy", "Creative", "Media", "SEO", "Content",
  "Social", "PR", "Web", "Analytics", "Experiential",
  "Partnerships", "Influence",
];

// Big kinetic editorial marquee band that also drifts with scroll direction.
export default function MarqueeBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const x = useTransform(scrollYProgress, [0, 1], ["6%", "-24%"]);

  const line = WORDS;

  return (
    <section
      ref={ref}
      data-testid="marquee-band"
      className="relative py-16 md:py-24 bg-[var(--bg-primary)] overflow-hidden border-y border-white/10"
    >
      <motion.div style={{ x }} className="flex whitespace-nowrap will-change-transform">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center">
            {line.map((w, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span
                  className={`font-display font-extrabold uppercase tracking-tight text-6xl md:text-8xl lg:text-9xl leading-none px-6 ${
                    i % 3 === 0
                      ? "text-white"
                      : i % 3 === 1
                      ? "text-stroke"
                      : "text-gradient-brand"
                  }`}
                >
                  {w}
                </span>
                <span className="text-[var(--accent-secondary)] text-4xl md:text-6xl px-2">✦</span>
              </span>
            ))}
          </div>
        ))}
      </motion.div>
    </section>
  );
}
